import React from 'react'
import {
    API_ARTICLES_BLOG_LIST,
    CFG_BLOG_ARTICLES_PER_PAGE,
    generateBlogCollectionSchema
} from "../../../settings/content/articles";
import getPages from "../../../helpers/data/get/pages";
import LayoutFull from "../../../layouts/layoutFull/LayoutFull";
import { URL_BASE } from "../../../settings/global";
import Blog from "../../../pagesComponents/blog/Blog";
import SeoApiHandler from "../../../helpers/seo/SeoApiHandler";
import { JSONLD } from "../../../helpers/seo/seo";
import Head from "next/head";
import { useRouter } from "next/router";
import { convertEditorStateToHTML, getPlainTextFromContent } from "../../../components/draftEditor/export/exports";
import { NAV_BLOG } from "../../../settings/navigation";

export async function getStaticPaths() {

    let paths = [];

    const res = await fetch(API_ARTICLES_BLOG_LIST);
    const posts = await res.json();
    let articles = posts.response.sort((a, b) => new Date(b.created) - new Date(a.created));
    articles = articles.filter(article => !!article.slug);

    const pages = Math.ceil(articles.length / CFG_BLOG_ARTICLES_PER_PAGE);

    for (let i = 1; i <= pages; i++) {
        paths.push({params: {page: i.toString()}})
    }

    return {
        paths,
        fallback: 'blocking',
    }
}

export async function getStaticProps({params}) {

    const res = await fetch(API_ARTICLES_BLOG_LIST);
    const posts = await res.json();
    let articles = posts.response.sort((a, b) => new Date(b.created) - new Date(a.created));
    articles = articles.filter(article => !!article.slug);

    const pagesCount = Math.ceil(articles.length / CFG_BLOG_ARTICLES_PER_PAGE);

    articles = articles.slice(
        (parseFloat(params.page) - 1) * CFG_BLOG_ARTICLES_PER_PAGE,
        parseFloat(params.page) * CFG_BLOG_ARTICLES_PER_PAGE
    );

    articles = articles.map(a => {
        return {
            ...a,
            ...{
                preview_plain: getPlainTextFromContent(a.preview),
                preview: convertEditorStateToHTML(a.preview, {}),
                content_plain: getPlainTextFromContent(a.content),
            }
        }
    })

    let pages = [];
    for (let i = 1; i <= pagesCount; i++) pages.push(i);

    if (isNaN(parseFloat(params.page)) || parseFloat(params.page) < 1 || parseFloat(params.page) > pages) {
        return {props: {}, notFound: true}
    }

    const seo = await getPages(NAV_BLOG);

    return {
        props: {
            articles,
            page: params.page,
            pages,
            seo,
            schemaData: generateBlogCollectionSchema(articles, null, seo.seo_description),
        }
    };
}

function BlogPage({articles, page, pages, seo, schemaData}) {

    const router = useRouter();

    return (
        <LayoutFull>
            <Head>
                {
                    page === '1'
                        ? <link rel="canonical" href={`${URL_BASE}${NAV_BLOG}`} key='canon'/>
                        : <link rel="canonical" href={`${URL_BASE}${NAV_BLOG}/page/${router.query.page}`} key='canon'/>
                }
            </Head>
            <SeoApiHandler data={seo}/>
            <JSONLD data={schemaData} tagKey={`blog-collection-${page}`}/>

            <Blog articles={articles} page={page} pages={pages}/>
        </LayoutFull>
    );
}

export default BlogPage